module.exports = __webpack_public_path__ + "img/bibLogo.f7f5601e.svg";